import { JwtHelperService } from '@auth0/angular-jwt';

import { AuthService, LOCALSTORAGE_AUTH_TOKEN, UserWithRights } from '@s2a/core';

import { SessionService } from '@s2a/ng-shell';

import { RouterService } from './router.service';
import { ShellAuthenticationService } from './shell-authentication.service';

export const setSessionFactory = (
  shellAuthenticationService: ShellAuthenticationService,
  sessionService: SessionService,
  routerService: RouterService,
  authService: AuthService,
): any => {
  const init = () =>
    new Promise<any>((resolve) => {
      if (authService.hasToken) {
        const jwtHelperService = new JwtHelperService();
        const userId = jwtHelperService.decodeToken(localStorage.getItem(LOCALSTORAGE_AUTH_TOKEN))[
          'custom:userId'
        ] as string;

        shellAuthenticationService.fetchUserWithRights(userId).subscribe((data: UserWithRights) => {
          sessionService.setUserInformation(data);
          resolve(data);
        });
      } else {
        routerService.redirectToLogin();
      }
    });

  return init;
};
